import React from "react"

const RichButton = ({button}) => {
    if(button.file !== null) {
        return (
            <a className="inline-block bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-800 hover:dark:bg-neutral-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={button.file.localFile.publicURL}>{button.title}</a>
        )
    } else {
        return (
            <a className="inline-block bg-neutral-200 hover:bg-neutral-300 dark:bg-neutral-800 hover:dark:bg-neutral-900 mr-1 mb-2 px-4 py-2 rounded-full leading-none" href={button.url}>{button.title}</a>
        )
    }
}

export default RichButton